import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Profile({ user, onUpdateUser }) {
    const [formData, setFormData] = useState({
        id: '',
        username: '',
        full_name: '',
        email: '',
        password: '',
        current_password: ''
    });
    const [profileImage, setProfileImage] = useState(null); // Mevcut resim URL
    const [imageFile, setImageFile] = useState(null); // Yüklenecek dosya

    useEffect(() => {
        if (user) {
            setFormData({
                id: user.id,
                username: user.username,
                full_name: user.full_name,
                email: user.email || '',
                password: '',
                current_password: ''
            });
            setProfileImage(user.profile_image);
        }
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setImageFile(e.target.files[0]);
            setProfileImage(URL.createObjectURL(e.target.files[0])); // Önizleme
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const data = new FormData();
        data.append('id', formData.id);
        data.append('username', formData.username);
        data.append('full_name', formData.full_name);
        data.append('email', formData.email);
        if (formData.password) {
            if (!formData.current_password) {
                toast.error("Şifre değiştirmek için mevcut şifrenizi girmelisiniz.");
                return;
            }
            data.append('password', formData.password);
            data.append('current_password', formData.current_password);
        }
        if (imageFile) {
            data.append('profile_image_file', imageFile);
        }

        axios.post('./backend/update_profile.php', data)
            .then(res => {
                toast.success(res.data.message);
                if (res.data.user && onUpdateUser) {
                    onUpdateUser(res.data.user);
                }
                setFormData(prev => ({ ...prev, password: '', current_password: '' })); // Şifreyi temizle
            })
            .catch(err => {
                toast.error(err.response?.data?.message || 'Güncelleme başarısız.');
            });
    };

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Profilim</h2>
            </div>
            <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', maxWidth: '600px' }}>
                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                        <div style={{ width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', marginBottom: '10px', border: '3px solid #4e73df' }}>
                            <img 
                                src={profileImage || 'https://zertucha.com/demos/dentis/uploads/logo_1770576275.png'} 
                                alt="Profil" 
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            />
                        </div>
                        <label htmlFor="profile-upload" style={{ cursor: 'pointer', color: '#4e73df', fontWeight: '600' }}>
                            Fotoğrafı Değiştir
                        </label>
                        <input 
                            id="profile-upload" 
                            type="file" 
                            accept="image/*" 
                            onChange={handleFileChange} 
                            style={{ display: 'none' }} 
                        />
                    </div>

                    <div className="form-group">
                        <label>Ad Soyad</label>
                        <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>E-posta</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="ornek@email.com" />
                    </div>
                    <div className="form-group">
                        <label>Kullanıcı Adı</label>
                        <input type="text" name="username" value={formData.username} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>Yeni Şifre (Değiştirmek istemiyorsanız boş bırakın)</label>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="******" />
                    </div>
                    {formData.password && (
                        <div className="form-group">
                            <label>Mevcut Şifre <span style={{color: 'red'}}>*</span></label>
                            <input type="password" name="current_password" value={formData.current_password} onChange={handleChange} required placeholder="Mevcut şifreniz" />
                        </div>
                    )}
                    <button type="submit" className="save-btn">Bilgileri Güncelle</button>
                </form>
            </div>
        </div>
    );
}

export default Profile;